import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import clsx from 'clsx';
import Immutable from 'immutable';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import WarningIcon from '@material-ui/icons/Warning';
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';
// import EventSubscription from 'components/EventSubscription/EventSubscription';
import RemainingTime from 'components/UI/RemainingTime';
// import EventSubscriptionVisitor from 'components/EventSubscription/EventSubscriptionVisitor';
// import EventSubscriptionFor from 'components/EventSubscription/EventSubscriptionFor';
import i18n from 'helpers/i18n';
import { formatDate } from 'helpers/stringUtils';
import getCardImage from 'helpers/getCardImage';
import getRemainingTime from 'helpers/getRemainingTime';
// import _compact from "lodash/compact";
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

const styles = (theme) => {
  return {
    root: {
      position: 'relative',
      border: '2px '+theme.palette.secondary.main+' solid',
      marginBottom: theme.spacing(4),
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(6),
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
      [theme.breakpoints.down('md')]: {
        // paddingTop: theme.spacing(8),
        // paddingBottom: theme.spacing(8),
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(4),
        paddingTop: theme.spacing(16),
        paddingBottom: theme.spacing(5),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },

    },
    themeSubTitle: {
      marginLeft: 'auto',
      marginRight: 'auto',
      fontSize: '1.2rem',
      width: '80%',
      textAlign: 'center',
      marginBottom: theme.spacing(2),
    },
    dateWrapper: {
      cursor: 'pointer',
      color: theme.palette.primary.main,
      border: '2px #fff solid',
      padding: 10,
      backgroundColor: theme.palette.secondary.main,
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        // marginBottom: 0,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
      },
      transition: [
        theme.transitions.create('background-color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        theme.transitions.create('color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        theme.transitions.create('box-shadow', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      ],
      '&:hover': {
        boxShadow: theme.shadows[7],
      },
      '& .MuiTypography-body1': {
        fontSize: '14px',
        lineHeight: '22px',
        letterSpacing: '1.17px',
        fontStyle: 'normal',
        // color: theme.palette.common.black,
        // fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
          fontSize: '12px',
          lineHeight: '16px',
        },
      },
      '& .MuiTypography-subtitle1, .MuiTypography-subtitle2 ': {
        color: 'inherit',
      },
    },
    dateWrapperTitle: {
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontSize: '0.8rem',
    },
    inline: {
      display: 'inline-block',
    },

    themeTitle: {
      fontSize: '2rem',
      // paddingBottom: theme.spacing(2),
      // borderBottom: '2px ' + theme.palette.primary.main + ' solid',
      // color: '#fff',
      textAlign: 'left',
      fontWeight: 'normal',
      textTransform: 'uppercase',
      marginBottom: 0,
    },
    themeDescription: {
      // fontSize: '2rem',
      // color: theme.palette.primary.main,
      fontSize: '1.1rem',
      // color: '#fff',
      textAlign: 'left',
      marginBottom: theme.spacing(2),
    },
    eventSubTitle: {
      // fontSize: '1.3rem',
      fontSize: '0.8rem',
      // paddingBottom: theme.spacing(2),
      // borderBottom: '2px ' + theme.palette.primary.main + ' solid',
      // color: '#fff',
      textAlign: 'left',
      fontWeight: 'normal',
      textTransform: 'uppercase',
      marginBottom: 0,
    },
    eventTitle: {
      fontSize: '1.6rem',
      textAlign: 'center',
      fontWeight: 'normal',
      color: theme.palette.secondary.main,
      marginBottom: 0,
    },

    description: {
      fontSize: '1.1rem',
      // color: '#fff',
      textAlign: 'left',
      width: '80%',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingRight: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        paddingRight: 0,
        marginBottom: theme.spacing(2),
      },
      [theme.breakpoints.down('sm')]: {
        width: '90%',
      }
    },
    dateWrapperSelected: {
      borderColor: theme.palette.primary.main,
      // backgroundColor: theme.palette.secondary.main,
      '& .MuiTypography-subtitle1, .MuiTypography-subtitle2 ': {
        // color: theme.palette.text.light,
      },
      '& .MuiSvgIcon-root': {
        // color: '#fff',
      },
    },
    dateWrapperActions: {
      padding: '0',
    },
    dateWrapperActionsButton: {
      transition: [
        theme.transitions.create('color', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        theme.transitions.create('opacity', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
      ],
      backgroundImage: 'none',
      color: theme.palette.text.light,
      backgroundColor: theme.palette.primary.main,
      fontSize: 22,
      fontWeight: 'bold',
      letterSpacing: '1px',
      padding: '0px 20px',
      border: '1px transparent solid',
      display: 'flex',
      '&:hover': {
        backgroundImage: 'none',
        border: '1px #fff solid',
        backgroundColor: '#fff',
        color: theme.palette.primary.main,
      },
    },
    subscriptionState: {
      position: 'absolute',
      right: 5,
      top: 5,
      '& .MuiSvgIcon-root': {
        color: 'inherit',
      },
    },

    badge: {
      position: 'absolute',
      transform: 'translate(-50%, -25%)',
      display: 'inline-block',
      color: '#fff',
      width: 'auto',
      padding: 20,
      fontSize: '0.8rem',
      top: 0,
      left: 0,
      [theme.breakpoints.down('sm')]: {
        left: '50%',
        transform: 'translate(-50%, -25%)',
        // marginBottom: theme.spacing(8),
        textAlign: 'center'
      },
      '&:before': {
        zIndex: '-1',
        transform: 'translate(0, -25%)',
        position: 'absolute',
        paddingTop: '100%',
        content: '" "',
        backgroundColor: theme.palette.primary.main,
        borderRadius: 180,
        width: '100%',
        top: 0,
        left: 0
      }
    }


  };
};

class EventCardEmbed extends Component {
  render() {
    const { classes, $$card, selected, gIdx, $$group, themeColor, onToggleCardSelect, showReplay, onReplaySelected, showDescription, userRole } = this.props;
    const $$data = $$card;
    const cardImage = getCardImage($$data) || '';
// console.log({showReplay})
    let isSelected;
    return (
      <Grid item xs={12} className={clsx(classes.root)}>
        <Grid
          item
          container
          xs={12}
          container
          spacing={0}
          alignItems="center"
          >

          <If condition={$$card.get('themeAbstract')}>
            <Grid item xs={12} container className={classes.badge}>
              <Paragrapher prettyfy={true} text={$$card.get('themeAbstract')} element={'div'}/>
            </Grid>
          </If>

          <If condition={userRole === 'staff'}>
            <Typography variant={'h2'} gutterBottom className={clsx(classes.titleWrapper)} style={{marginBottom: 48}}>
              J'AI LE PLAISIR DE VOUS INVITER À LA WEBCONFÉRENCE :
            </Typography>
          </If>


          <Typography variant={'h2'} className={clsx(classes.titleWrapper)}>
            <span className={classes.titleLabel}>
              <Paragrapher prettyfy={true} text={$$card.get('themeName')} />
            </span>
          </Typography>
          <If
            condition={
              $$card.get('themeSubTitle') !== undefined &&
              $$card.get('themeSubTitle') !== '' &&
              $$card.get('themeSubTitle') !== null
            }
            >
            <Typography
              variant={'body1'}
              gutterBottom={true}
              className={clsx(classes.themeSubTitle, {})}
              component={'div'}
              >
              <Paragrapher element={'div'} text={$$card.get('themeSubTitle')} prettyfy={true} />
            </Typography>
          </If>
          <If condition={$$card.get('themeDescription')}>
            <Typography
              variant={'body1'}
              gutterBottom={true}
              className={clsx(classes.themeDescription, {})}
              component={'div'}
              >
              <Paragrapher
                element={'div'}
                text={$$card.get('themeDescription')}
                prettyfy={true}
                />
            </Typography>
          </If>
          <Grid item xs={showDescription !== false || $$group === undefined ? 12 : 9}>
{/*            <Typography variant={'h4'} className={classes.eventTitle}>
              <Paragrapher text={$$card.get('eventTitle')} prettyfy={true} element={'span'} />
            </Typography>*/}
            <If condition={$$card.get('eventGuestsDescription')}>
              <div className={classes.description}>
                <Typography variant={'body1'} className={classes.eventTitle}>
                  <Paragrapher text={$$card.get('eventGuestsDescription')} prettyfy={true} element={'span'} />
                </Typography>
              </div>
            </If>
          </Grid>
          <If condition={showDescription !== false}>
            <Grid item xs={12}>
              <div className={classes.description}>
                <Paragrapher text={$$card.get('eventDescription')} prettyfy={true} />
              </div>
            </Grid>
          </If>
          <If condition={showReplay !== true}>
          <Grid item xs={12}>
            <Box mt={4} mb={2}>
            <Typography variant="h4" align="center" gutterBottom>
              Choisissez votre session puis cliquez sur Etape suivante
            </Typography>
            </Box>
          </Grid>
          </If>

          <Grid item xs={12}  container justify="center">
            <If condition={$$group !== undefined}>
              {$$group.map(($$e, eIdx) => {
                isSelected = selected.indexOf($$e.get('id')) >= 0;
                return (<Grid item xs={12} sm={6} md={4} key={'d_'+gIdx+'_'+eIdx}>
                <Paper
                  align="center"
                  elevation={3}
                  className={clsx(classes.dateWrapper, {
                    [classes.dateWrapperSelected]: isSelected,
                  })}
                  style={{
                    backgroundColor: isSelected ? themeColor : undefined,
                    position: 'relative',
                    color: isSelected ? undefined : themeColor,
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    onToggleCardSelect($$e.get('id'));
                  }}
                  >
                  <If condition={isSelected === true}>
                    <Typography variant={'caption'} gutterBottom className={classes.subscriptionState}>
                      <CheckBoxIcon style={{ color: 'inherit' }} />
                    </Typography>
                  </If>
                  <If condition={isSelected !== true}>
                    <Typography variant={'caption'} gutterBottom className={classes.subscriptionState}>
                      <CheckBoxOutlineBlankIcon style={{ color: 'inherit' }} />
                    </Typography>
                  </If>

                  <Box style={{ color: themeColor, width: '100%' }}>
                    <Typography variant={'subtitle1'} className={classes.dateWrapperTitle}>
                      {formatDate($$e.get('eventDate'), 'dddd dd mmmm')}
                    </Typography>
                    <Typography variant={'subtitle2'}>
                      <span className={classes.inline}>
                        {formatDate($$e.get('eventDate'), "HH'h'MM")}
                      </span>
                    </Typography>
                  </Box>
                </Paper>
              </Grid>);
            }).toArray()}
          </If>
          <If condition={showReplay === true}>
            <Button variant="contained" size="large" onClick={onReplaySelected}>Voir le Replay</Button>
          </If>

        </Grid>
      </Grid>
    </Grid>
  );
}
}

export default withRouter(withStyles(styles)(EventCardEmbed));



// WEBPACK FOOTER //
// ./src/components/UI/Event/EventCardEmbed.jsx